import { createStyles, Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { memo, type ReactNode } from 'react';

const useStyles = createStyles((theme) => ({
	popoverTarget: {
		cursor: 'pointer',
	},
	dropdown: {
		backgroundColor: theme.other.getColor('surface/primary/default'),
		border: `1px solid ${theme.other.getColor('border/primary/default')}`,
		borderRadius: theme.other.borderRadius.md,
		boxShadow: theme.shadows.md,
		padding: `${theme.other.space[2]} 0 ${theme.other.space[2]} ${theme.other.space[3]}`,
	},
}));

interface PopoverPreviewProps {
	preview: ReactNode;
	dropdown: ReactNode;
	width?: number;
	isInteractive?: boolean;
}

export const PopoverPreview = memo(
	({
		preview,
		dropdown,
		width = 320,
		isInteractive = true,
	}: PopoverPreviewProps) => {
		const { classes, theme } = useStyles();
		const [opened, { open, close }] = useDisclosure(false);

		if (!isInteractive) {
			return <>{preview}</>;
		}

		return (
			<Popover
				opened={opened}
				width={width}
				position="bottom"
				shadow="md"
				withinPortal
				radius="md"
				classNames={{ dropdown: classes.dropdown }}
				styles={{
					arrow: {
						backgroundColor: theme.other.getColor('surface/primary/default'),
						border: `1px solid ${theme.other.getColor('border/primary/default')}`,
					},
				}}
				disabled={!isInteractive}
			>
				<Popover.Target>
					<div
						onMouseEnter={open}
						onMouseLeave={close}
						className={classes.popoverTarget}
					>
						{preview}
					</div>
				</Popover.Target>
				<Popover.Dropdown onMouseEnter={open} onMouseLeave={close}>
					{dropdown}
				</Popover.Dropdown>
			</Popover>
		);
	}
);
